import { render, staticRenderFns } from "./PaymentsCompletedProgressBar.vue?vue&type=template&id=38bbba54"
import script from "./PaymentsCompletedProgressBar.vue?vue&type=script&lang=js"
export * from "./PaymentsCompletedProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports